import { Navigate } from "react-router-dom";

import { DashboardPage } from "@/pages/dashboard";
import { useAuth } from "@/stores/auth";

/** Index "/" — clientes/técnicos vão pro portal; demais veem o dashboard admin. */
export function RoleHome() {
  const { user, impersonation } = useAuth();
  const role = user?.role;
  if (!impersonation && (role === "client" || role === "nerd")) {
    return <Navigate to="/portal" replace />;
  }
  return <DashboardPage />;
}
